import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  UnarchiveTagMutation,
  UnarchiveTagMutationVariables,
} from '@/gql/graphql';

const UnarchiveTag = graphql(`
  mutation UnarchiveTag($input: UnarchiveTagInput!) {
    unarchiveTag(input: $input) {
      id
    }
  }
`);

const useUnarchiveTag = (
  options?: UseMutationOptions<
    UnarchiveTagMutation,
    unknown,
    UnarchiveTagMutationVariables['input']
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UnarchiveTag, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountAvailableTags(),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUnarchiveTag;
